// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productPrimaryImageStyles } from "@vanmeter/Overrides/Components/ProductPrimaryImage";
import { xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

productPrimaryImageStyles.centeringWrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        img {
            height: auto;
            max-width: 100%;
            aspect-ratio: 1;
        }
    `,
};

productPrimaryImageStyles.skeletonStyle = {
    css: css`
        ${xScreen("lte", "md")} {
            width: 358px;
            min-height: 358px;
        }
        ${xScreen("lte", "sm")} {
            width: 100%;
            min-height: 100%;
        }
    `,
};
